import { render, staticRenderFns } from "./area-key-table.component.vue?vue&type=template&id=039fd0b7&scoped=true&"
import script from "./area-key-table.component.vue?vue&type=script&lang=ts&"
export * from "./area-key-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./area-key-table.component.vue?vue&type=style&index=0&id=039fd0b7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039fd0b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VSimpleTable})
